export default {
	"indexTitle": {
		"title1": "注册",
		"title2": "登录",
		"title3": "手机下载",
		"title4": "充值",
		"title5": "提现",
		"title6": "体育",
		"title7": "真人",
		"title8": "电子",
		"title9": "棋牌",
		"title10": "捕鱼",
		"title11": "实况",
		"title12": "电竞",
		"title13": "彩票",
		"title14": "优惠活动",
		"title15": "手机下载",
		"title16": "热门游戏",
		"title17": "开始游戏",
		"title18": "最新消息",
		"title19": "请注意使用支付宝、八达通、tap&go、BOC等类别银行入款，请必须选择转数快并核对收款人英文全名！",
		"title20": "全部优惠",
		"title21": "申请此优惠",
		"title22": "我要遊戲",
		"title23": "余额",
		"title24": "我的帐户",
		"title25": "VIP",
		"title26": "充值",
		"title27": "提款",
		"title28": "推广分销",
		"title29": "任务日志",
		"title30": "优惠中心",
		"title31": "游戏记录",
		"title32": "财务记录",
		"title33": "公告中心",
		"title34": "推广分销",
		"title35": "直属成员",
		"title36": "我的佣金",
		"title37": "规则说明",
		"title38": "团队人数",
		"title39": "今日团队新增",
		"title40": "直属人数",
		"title41": "今日直属新增",
		"title42": "今日团队流水",
		"title43": "今日直属流水",
		"title44": "推广收益",
		"title45": "奖金",
		"title46": "下线人数",
		"title47": "预估可以获得高额奖金",
		"title48": "个人信息",
		"title49": "推荐代码",
		"title50": "邀请链接",
		"title51": "邀请二维码",
		"title52": "推广工具",
		"title53": "下载",
		"title54": "我的账户",
		"title55": "新密码",
		"title56": "修改取款密码",
		"title57": "旧密码",
		"title58": "必填",
		"title59": "请输入登入密码",
		"title60": "确认新密码",
		"title61": "取消",
		"title62": "更新",
		"title63": "请输入旧密码",
		"title64": "请输入新密码",
		"title65": "两次密码不同",
		"title66": "更新失败",
		"title67": "登录密码",
		"title68": "新取款密码",
		"title69": "6~10位英文与数字组合(可包含特殊字元)",
		"title70": "确认取款密码",
		"title71": "请输入登录密码",
		"title72": "请输入新取款密码",
		"title73": "存款方式选项",
		"title74": "优惠",
		"title75": "暂无资料",
		"title76": "转数快",
		"title77": "便利商店增值",
		"title78": "无充值限额",
		"title79": "手续费",
		"title80": "无手续费",
		"title81": "请输入充值金额",
		"title82": "请输入付款姓名",
		"title83": "充值赠送",
		"title84": "请选择",
		"title85": "获取付款信息",
		"title86": "支付教程",
		"title87": "1.请选择支付通道后，填入金额，点击提交。",
		"title88": "2.跳转第三方支付页面后，依据页面程序进行存款并在时限内完成。",
		"title89": "3.支付完成后，等待页面显示支付成功信息后，再将页面关闭，以免发生掉单的情形。",
		"title90": "4.等待第三方平台确认后，系统将自动添加到您的帐号。",
		"title91": "5.支付未到帐？无法支付？请联系【在线客服】进行咨询。",
		"title92": "充值金额",
		"title93": "请记录以下收款资讯,并汇款",
		"title94": "收款帐号",
		"title95": "收款帐户名",
		"title96": "收款二维码",
		"title97": "充值地址",
		"title98": "返回重新输入",
		"title99": "确认充值",
		"title100": "复制成功！",
		"title101": "开始",
		"title102": "结束",
		"title103": "可查询当日往前31天的资料",
		"title104": "查询",
		"title105": "存款总计",
		"title106": "提款总计",
		"title107": "优惠总计",
		"title108": "返水记录",
		"title109": "手动调整记录",
		"title110": "推荐记录",
		"title111": "任务奖励记录",
		"title112": "*存取數據時可能會延遲，若未找到遊戲紀錄，請稍後重試。 總覽資料固定GMT+8時間做加總，只顯示近10日資料",
		"title113": "产品类型",
		"title114": "游戏",
		"title115": "日期",
		"title116": "总投注",
		"title117": "总有效投注",
		"title118": "总输赢",
		"title119": "已结算",
		"title120": "投注额",
		"title121": "交易编号",
		"title122": "暂无记录",
		"title123": "个人资料",
		"title124": "银行卡资料",
		"title125": "所有钱包",
		"title126": "修改 登录/取款 密码",
		"title127": "推荐码",
		"title128": "玩家帐号",
		"title129": "真实姓名",
		"title130": "手机号码",
		"title131": "注册时间",
		"title132": "总金额",
		"title133": "新增银行卡",
		"title134": "银行卡号",
		"title135": "开户人名字",
		"title136": "必须与您的银行帐户姓名一致，否则无法进行取款",
		"title137": "收款银行",
		"title138": "银行账号",
		"title139": "请输入您的银行账号",
		"title140": "开户行网点",
		"title141": "请输入您的开户行网点",
		"title142": "确认",
		"title143": "请输入开户人名字",
		"title144": "请输入收款银行",
		"title145": "请输入银行账号",
		"title146": "请输入开户行网点",
		"title147": "倒数时间",
		"title148": "每日存款",
		"title149": "港元以上",
		"title150": "活动点数",
		"title151": "点",
		"title152": "累计登入",
		"title153": "天以上",
		"title154": "已完成",
		"title155": "可领取",
		"title156": "任务准备中",
		"title157": "平台公告",
		"title158": "总计",
		"title159": "申请时间",
		"title160": "审核时间",
		"title161": "待确认",
		"title162": "成功",
		"title163": "失败",
		"title164": "实际金额",
		"title165": "备注",
		"title166": "订单号",
		"title167": "更多内容",
		"title168": "VIP等级",
		"title169": "当前等级",
		"title170": "VIP权益说明",
		"title171": "晋级",
		"title172": "条件",
		"title173": "通过",
		"title174": "当前积分",
		"title175": "恭喜达成",
		"title176": "专属特权",
		"title177": "等级不足",
		"title178": "生日礼金",
		"title179": "领取",
		"title180": "积分历程",
		"title181": "等级升降",
		"title182": "领取记录",
		"title183": "提款金额",
		"title184": "稽核总扣除",
		"title185": "提款密码",
		"title186": "实际提领",
		"title187": "提款金额应介于 1.00 与 10.00 之间",
		"title188": "请先绑定银行卡",
		"title189": "请输入提现金额",
		"title190": "请输入提现密码",
		"title191": "玩家登录",
		"title192": "帐    号",
		"title193": "密    码",
		"title194": "还未注册?立即点击",
		"title195": "忘记帐号",
		"title196": "忘记密码",
		"title197": "请输入玩家账号",
		"title198": "请输入玩家密码",
		"title199": "玩家帐户必须6-12位",
		"title200": "China (中国)",
		"title201": "Hong Kong (香港)",
		"title202": "重新输入",
		"title203": "立即注册",
		"title204": "请输入帐号",
		"title205": "请输入密码",
		"title206": "请输入手机号",
		"title207": "每日任务",
		"title208": "轮盘",
		"title209": "推荐进度",
		"title210": "联系我们",
		"title211": "关于我们",
		"title212": "登出",
		"title213": "免费注册",
		"title214": "体育赛事",
		"title215": "真人娱乐",
		"title216": "电子游戏",
		"title217": "棋牌",
		"title218": "捕鱼游戏",
		"title219": "动物竞技",
		"title220": "电子竞技",
		"title221": "Android 扫一扫",
		"title222": "iOS 手机扫一扫",
		"title223": "立即游戏",
		"title224": "活动时间:",

		"title225": "取款密码",
		"title226": "支付通道",
		"title227": "全部",
		"title228": "玩家充值",
		"title229": "存款记录",
		"title230": "帮助中心",
		"title231": "存款帮助",
		"title232": "您好,",
		"title233": "银行卡管理",
		"title234": "每日任务",
		"title235": "累计任务",
		"title236": "期间任务",
		"title237": "签到任务",
		"title238": "未开通",
		"title239": "修改提款密码",
		"title240": "玩家账号",
		"title241": "轮盘点数",
		"title242": "真实姓名",
		"title243": "手机号码",
		"title244": "生日日期",
		"title245": "注册时间",
		"title246": "上次登录密码",
		"title247": "vip记录",
		"title248": "提款记录",
		"title249": "可提款金额",
		"title250": "优惠稽核",
		"title251": "扣除额",
		"title252": "行政费用",
		"title253": "手续费",
		"title254": "优惠金",
		"title255": "常态稽核",
		"title256": "第",
		"title257": "天",
		"title258": "金额：",
		"title259": "获取金额：",
		"title260": "码量：",
		"title261": "签到",
		"title262": "已签到",
		"title263": "总签到天数：",
		"title264": "总签到收益：",
		"title265": "当日充值金额：",
		"title266": "当日有效投注：",
		"title267": "要求存款数量：",
		"title268": "要求有效码量数量：",
		"title269": "转盘次数：",
		"title270": "次",
		"title271": "今日已完成该任务",
		"title272": "未达标",

		"title273": "首页",
		"title274": "优惠",
		"title275": "赚钱",
		"title276": "账户",
		"title277": "未到签到天数",
		"title278": "签到条件",
		"title279": "已达成!",
		"title280": "需先完成身份认证金级",
		"title281": "即可参与此活动",
		"title282": "签到送奖金",
		"title283": "活动天数共",
		"title284": "总奖金",
		"title285": "选择币种",
		"title286": "请输入英文名字",
		"title287": "账号最少6位",
		"title288": "银行账户",
		"title289": "最低：",
		"title290": "最高：",
		"title291": "充值额度",
		"title292": "充值额度最低",
		"title293": "充值额度最高",
		"title294": "登录状态失效，请重新登录",
		"title295": "银行卡名称",
		"title296": "开户银行",
		"title297": "银行卡账号",
		"title298": "请输入6位数字提款密码",
		"title299": "此动作将把所有余额转回主钱包，是否继续？",
		"title300": "取消",
		"title301": "继续",
		"title302": "提款密码6位数",
		"title303": "资金回收",
		"title304": "客服",
		"title305": "余码量",
		"title306": "实时返水",
		"title307": "领取",
		"title308": "最低充值金额",
		"title309": "下载苹果版",
		"title310": "支持苹果",
		"title311": "以上",
		"title312": "下载安卓版",
		"title313": "支持安卓",
		"title314": "微信玩家请用手机浏览器",
		"title315": "点击复制网址",

		"title316": "活动奖品",
		"title317": "我的奖品",
		"title318": "转盘",
		"title319": "赠送彩金：",
		"title320": "要求真人有效投注数量：",
		"title321": "要求捕鱼有效投注数量：",
		"title322": "要求电子有效投注数量：",
		"title323": "要求彩票有效投注数量：",
		"title324": "要求体育有效投注数量：",
		"title325": "要求棋牌有效投注数量：",
		"title326": "要求其他有效投注数量：",
		"title327": "百家乐",

		"title328": "实时返水",
		"title329": "点击领取",
		"title330": "元",
		"title331": "真人返水金额：",
		"title332": "体育返水金额：",
		"title333": "电子返水金额：",
		"title334": "棋牌返水金额：",
		"title335": "领取说明",
		"title336": "领取时间为16:00:00-23:59:59,如未在此时间段内领取则清零",
		"title337": "仅提供14天内交易资料查询",
		"title338": "捕鱼返水金额：",
		"title339": "电竞返水金额：",
		"title340": "动物电竞返水金额：",
		"title341": "主钱包",
		"title342": "游戏钱包",
		"title343": "线路选择",
		"title344": "客服（线路一）",
		"title345": "客服（线路二）",
		"title346": "有效投注",
		"title347": "不参与活动",
		"title348":"签到活动",
		"title349":"轮盘抽奖",
		"title350":"先去逛逛",
		"title351":"记住密码",
		"title352": "请输入转数快账号",
		"title353": "请输入",
		"title386": "当前可领取",
		"title387": "领取奖励",
		"title388": "红包奖金",
		"title389": "高达",
		"title451": "升至",
		"title452": "规则",
		"title453": "等级",
		"title454": "晉級獎金",
		"title455": "週禮金",
		"title456": "月禮金",
		"title458": "VIP等级制度",
		"title459": "保级经验值",
		"title460": "升级经验值",
		"title461": "晉升標準",
		"title462": "會員達到相應級別的有效打碼量要求，系統將會自動判斷並晉級相應vip等級。（每晉級相應vip等級有效打碼量將重新計算）。",
		"title463": "保級要求",
		"title464": "會員在達到某VIP等級後，60天內需要完成保級有效打碼量要求（當前等級晉升所需有效打碼量的一半等於保級有效打碼量）。如果在此期間完成晉升，保級要求重新按照當前等級計算。",
		"title465": "降級標準",
		"title466": "會員在60天內，沒有完成相應的保級要求，系統將會自動降級一個等級（每降至相應VIP等級有效投注額將重新計算），相應的優惠也會隨之調整至降級後的等級。",
		"title467": "晉級禮金",
		"title468": "晉級禮金在會員晉升等級後，即可在VIP頁面領取晉級彩金，每個級別的晉級禮金僅能獲得1次，晉級禮金需完成1倍打碼量即可提款。",
		"title469": "VIP周紅包",
		"title470": "VIP紅包每週即可領取一次，紅包金額根據當前等級可領取相應的金額，逢週一00:00更新逾期則無法領取上週紅包彩金，紅包1倍有效打碼量即可提款，每周限參與一次。",
		"title471": "VIP月紅包",
		"title472": "VIP紅包每月即可領取一次，紅包金額根據當前等級可領取相應的金額，逢一號00:00更新逾期則無法領取上月紅包彩金，紅包1倍有效打碼量即可提款，每月限參與一次。",
		"title473": "VIP俱乐部",
		"title477": "该奖励已领取",
		"title478": "本周已领取",
		"title479": "本月已领取",
		"title399": "当日存款",
		"title400": "当日流水",
		"title403": "红包申请：此活动当日存款金额",
		"title404": "流水金额",
		"title405": "当日可以在活动页面点击立即领取。",
		"title406": "此活动领取彩金，仅1倍流水提款。",
		"title407": "此活动每位玩家每天可申请一次，随机红包金额最高",
		"title408": "每位玩家仅能注册一个账户，如注册多个账户参与活动则被视为多账户套利，平台将禁用封锁该账户。",
		"title409": "本平台保留对此活动做出更改、终止的权利，并享有最终解释权。",
		"title480": "本日已领取",
		"title520": "活动详情",
		"title521": "领取",
		"title610": "红包活动",
		"title437": "代理佣金",
		"title438": "推荐代码",
		"title440": "领取纪录",
		"title441": "昨日好友有效投注",
		"title443": "存款提现有什么要求?",
		"title444": "存款最低金額100，提款最低金額100。代理支持USDT提款金額需達10000以上，並聯絡客服綁定USDT提款。佣金需一倍有效投注提款。",
		"title445": "推荐奖金如何计算?",
		"title446": "推薦獎金計算方式，邀請下線註冊並投注即可獲取下線會員的0.8%返水。計算方式如下：下線會員投注金額為5000000，則可以領取佣金為5000000*0.8%= 40000佣金。",
		"title447": "红利奖金多久结算一次?",
		"title448": "代理佣金實時結算，如下線會員投注即刻可以獲取佣金。",
		"title474": "复制",
		"title475": "邀请好友",
		"title476": "业绩查询",
		"title494": "已領取佣金獎勵",
		"title532": "利息宝",
		"title535": "总金额 (￥)",
		"title536": "年利率",
		"title537": "转入",
		"title538": "领取",
		"title539": "转出",
		"title540": "当前收益",
		"title541": "总计彩金",
		"title542": "累计收益",
		"title543": "明细详情",
		"title544": "利息宝规则",
		"title545": "收益明细",
		"title546": "领取记录",
		"title547": "转出记录",
		"title548": "转入记录",
		"title549": "收益",
		"title550": "暂无记录",
		"title553": "请输入金额",
		"title554": "确认",
		"title555": "利息规则\n• 主账户资金需满足提款码量后才能转入利息宝。\n• 按年利率计算，每小时为一个结算周期，收益公式如下：\n利息宝金额 × 年利率 ÷ 365 ÷ 24 = 每小时收益。\n• 需存入 2 小时后才开始计算收益，转出彩金奖励不受影响。\n• 单次存入的最高结算周期为 12 小时，超过 12 小时需重新存入才能继续计算利息。\n• 以 365 % 年利率为例，若利息宝金额为 100,000，则12小时的利息收益约为 500。\n\n转出规则\n奖励比例：\n• 每笔从利息宝转出至主账户才获得1%彩金奖励，每天最多2次，1%奖励上限为388。\n转出要求：\n• 转出至主帐户后，需完成 「转出金额 + 彩金」的 1 倍打码量方可提款。",
		"title556": "操作失败，请稍后重试",
		"title557": "主钱包余额(￥)",
		"title558": "利息宝钱包(￥)",
		"title559": "转入金额",
		"title561": "主账户金额需完成打码量并满足提款条件后，方可转入利息宝。可通过打码量检查是否符合转入条件。",
		"title562": "转出",
		"title563": "全部余额",
		"title564": "未领取收益",
		"title565": "转出金额",
		"title566": "赠送金额",
		"title567": "彩金奖励规则：",
		"title568": "1.转出赠送{rate}%，2次/天",
		"title569": "2.转出后「本金+彩金」需要完成1倍打码量",
		"title571": "暂无可转出余额",
		"title573": "转出赠送",
	},

};